import { Outlet, useLocation } from "react-router";
import { Grid } from "react-flexbox-grid";
import styled from "styled-components";

import Header from "./Header";
import BtcTicker from "./BtcTicker";
import Footer from "./Footer";
import ErrorBoundary from "./ErrorBoundary";

const StyledGrid = styled(Grid)`
  padding: 0 !important;
`;

function Layout() {
  const { pathname } = useLocation();
  return (
    <StyledGrid fluid>
      <Header />
      {/* Outside the ErrorBoundary below on purpose: that one is scoped to the
          routed page, and the ticker is chrome. It sits here rather than inside
          Header because the header is sticky - a bar stuck to the top on every
          page costs vertical space a phone does not have, and the gap it fills
          is under the header, not in it. */}
      <BtcTicker />
      {/* resetKey clears the error when the route changes, so a crash on one
          page does not wedge every other page too */}
      <ErrorBoundary resetKey={pathname}>
        <Outlet />
      </ErrorBoundary>
      <Footer />
    </StyledGrid>
  );
}

export default Layout;
